import CusModal from "./CusModal";

export default CusModal;